// Action Types
const SET_LOADING = "loading/SET_LOADING";
const SET_LOADING_MESSAGE = "loading/SET_LOADING_MESSAGE";
const RESET_LOADING = "loading/RESET_LOADING";

// Initial State
const initialState = {
    isLoading: false,
    message: "",
    // Track if navigation should be disabled
    disableNavigation: false,
};

// Action Creators
export const setLoading = (isLoading, disableNavigation = true) => ({
    type: SET_LOADING,
    payload: { isLoading, disableNavigation },
});

export const setLoadingMessage = (message) => ({
    type: SET_LOADING_MESSAGE,
    payload: message,
});

export const resetLoading = () => ({
    type: RESET_LOADING,
});

// Thunk action for starting loading with optional message
export const startLoading = (message = "") => (dispatch) => {
    dispatch(setLoading(true, true));
    if (message) {
        dispatch(setLoadingMessage(message));
    }
};

// Thunk action for stopping loading
export const stopLoading = () => (dispatch) => {
    dispatch(setLoading(false, false));
    dispatch(setLoadingMessage(""));
};

// Reducer
export const loadingReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                isLoading: action.payload.isLoading,
                disableNavigation: action.payload.disableNavigation,
            };
        case SET_LOADING_MESSAGE:
            return {
                ...state,
                message: action.payload,
            };
        case RESET_LOADING:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};

// Selectors
export const selectIsLoading = (state) => state.Loading?.isLoading ?? false;
export const selectLoadingMessage = (state) => state.Loading?.message ?? "";
export const selectDisableNavigation = (state) => state.Loading?.disableNavigation ?? false;
